import React from "react";

/**
 * Minimal, brand-consistent fallback shown while a lazy-loaded
 * route chunk is being fetched. Uses an opaque dark surface so it
 * sits cleanly over the global grid background and avoids any
 * jarring white flash during chunk hydration.
 */
export default function RouteFallback() {
  return (
    <div
      data-testid="route-suspense-fallback"
      className="min-h-screen w-full flex items-center justify-center"
      style={{ background: "#000000" }}
    >
      <div className="flex items-center gap-3 text-[#7AE7F2]">
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 rounded-full animate-pulse"
          style={{ background: "#7AE7F2", boxShadow: "0 0 12px #7AE7F2" }}
        />
        <span
          className="text-xs tracking-[0.2em] uppercase"
          style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
        >
          Loading
        </span>
      </div>
    </div>
  );
}
